// extracted by mini-css-extract-plugin
export default {"csslightbox":"lightbox_csslightbox__44ABC","lightbox":"lightbox_lightbox__kSNb9"};